<template>
  <b-modal
    id="modal_active_features"
    title="Nouvelles fonctionnalités"
    scrollable
    hide-footer
  >
  <div>
    <b-table
      :fields="fields"
      :items="computedFeatures"
      :busy="loadingList"
    >
    <template v-slot:table-busy>
      <div class="text-center my-2">
        <strong>Chargement ...</strong>
      </div>
    </template>

    <template #cell(name)="row">
      {{ $t('label.' + row.item.common_name) }} <span v-show="needAsterisk(row.item.common_name)">*</span>
    </template>
      <template #cell(value)="row">
        <b-form-checkbox v-model="row.item.enable" name="check-button" switch />
      </template>
    </b-table>
    <div v-show="haveTemplateForm" class="text-center">
      L'établissement a un template permettant de créer des formulaires d'entrée pour les futures résidents.
    </div>
    <div v-show="!haveTemplateForm" class="text-center">
      L'établissement <b>n'a pas</b> de template permettant de créer des formulaires d'entrée pour les futures résidents.<br>
      En activant '{{ $t('label.resident_entrance_form') }}' ou '{{ $t('label.resident_entrance_form_short_stay') }}', ce template sera créé automatiquement.
    </div>
    <div class="text-center">
      * Les éléments ne sont activable seulement si le profil résident est activé.
    </div>
    <br>
    <b-button block variant="primary" @click="updateFeatures" :disabled="loading">{{ $t('btn.update') }}</b-button>
  </div>
  </b-modal>
</template>

<script>
import { isExtraFeaturesActive, applyExtraFeatures } from '../services/establishment';

export default {
  props: {
    establishment: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      features: [],
      loading: false,
      loadingList: true,
    }
  },
  computed: {
    // Ordre personnalisé : les clés définies ici seront placées dans cet ordre
    // Les clés non définies seront placées à la fin dans leur ordre original
    customKeyOrder() {
      return [
        'hide_gir',
        'hide_troubles',
        'resident_profile',
        'resident_entrance_form',
        'resident_entrance_form_short_stay',
        'resident_interests',
        'custom_scheduling',
      ];
    },
    computedFeatures() {
      const features = Object.keys(this.features)
        .filter(key => this.features[key].name !== 'template')
        .map(key => this.features[key]);

      // Trier selon l'ordre personnalisé
      return features.sort((a, b) => {
        const indexA = this.customKeyOrder.indexOf(a.common_name);
        const indexB = this.customKeyOrder.indexOf(b.common_name);

        // Si les deux clés sont dans l'ordre personnalisé
        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }
        // Si seule la clé A est dans l'ordre personnalisé, elle passe en premier
        if (indexA !== -1) {
          return -1;
        }
        // Si seule la clé B est dans l'ordre personnalisé, elle passe en premier
        if (indexB !== -1) {
          return 1;
        }
        // Aucune des deux n'est dans l'ordre personnalisé, garder l'ordre original
        return 0;
      });
    },
    haveTemplateForm() {
      return this.features.find(f => f.name === 'template')?.enable ?? false;
    },
    fields() {
      return [
        {
          name: {
            label: 'Nom',
            sortable: false,
          },
        },
        {
          value: {
            label: 'Inactif/Actif',
            sortable: false,
          }
        }
      ]
    }
  },
  async mounted() {
    await this.loadList()
  },
  methods: {
    hide() {
      this.$bvModal.hide("modal_active_features");
    },
    async loadList() {
      this.loadingList = true;
      this.features = await isExtraFeaturesActive(this.establishment.esta_id);
      this.loadingList = false;
    },
    async updateFeatures() {
      this.loading = true;
      try {
        await applyExtraFeatures(this.establishment.esta_id, this.features);
        this.showToast('success', 'Les fonctionnalités ont été mises à jour avec succès', 'Nouvelles fonctionnalités')
        this.hide();
      } catch {
        // no op
      }
      await this.loadList();
      this.loading = false;
    },
    needAsterisk(name) {
      return [
        'resident_entrance_form', 'resident_entrance_form_short_stay', 'resident_interests', 'custom_scheduling'].indexOf(name) !== -1;
    }
  }
}
</script>
